var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepsInactive02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12,
    fill: "#666C73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3906 19H10.6162V17.7832L13.1934 15.1924C13.9544 14.4131 14.458 13.8617 14.7041 13.5381C14.9548 13.21 15.137 12.9023 15.251 12.6152C15.3649 12.3281 15.4219 12.0205 15.4219 11.6924C15.4219 11.2412 15.2852 10.8857 15.0117 10.626C14.7428 10.3662 14.3691 10.2363 13.8906 10.2363C13.5078 10.2363 13.1364 10.307 12.7764 10.4482C12.4209 10.5895 12.0085 10.8447 11.5391 11.2139L10.6709 10.1543C11.2269 9.6849 11.7669 9.35221 12.291 9.15625C12.8151 8.96029 13.3734 8.8623 13.9658 8.8623C14.8955 8.8623 15.6406 9.10612 16.2012 9.59375C16.7617 10.0768 17.042 10.7285 17.042 11.5488C17.042 12 16.96 12.4284 16.7959 12.834C16.6364 13.2396 16.388 13.6589 16.0508 14.0918C15.7181 14.5202 15.1621 15.1012 14.3828 15.835L12.6465 17.5166V17.585H17.3906V19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsInactive02);
export default __webpack_public_path__ + "static/media/StepsInactive02.b6e0a3b4ce3d187e323982a591b34ceb.svg";
export { ForwardRef as ReactComponent };